module.exports = __webpack_public_path__ + "static/media/btg_12.5a84b0f0.png";